module.exports = __webpack_public_path__ + "img/oya_home.271d83b3.jpg";